<div class="paddedContent">
  <div class="column" style="text-align: center; margin-top: 15px">
    <input
      type="button"
      class="button_primary button_var_2 button_right-spacing"
      (click)="btnSubmit_click()"
      value="Save"
    />
    <input
      type="button"
      class="button_primary button_var_2"
      (click)="btnClose_click()"
      value="Cancel"
    />
  </div>

  <app-merchant-application
    [type]="selectedProcessorType"
  ></app-merchant-application>

  <div class="column" style="text-align: center; margin-top: 15px">
    <input
      type="button"
      class="button_primary button_var_2 button_right-spacing"
      (click)="btnSubmit_click()"
      value="Save"
    />
    <input
      type="button"
      class="button_primary button_var_2"
      (click)="btnClose_click()"
      value="Cancel"
    />
  </div>
</div>
